var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"overview-action-button btn btn-block btn-lg",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClicked}},[_c('i',{class:['far', 'fa-fw', _vm.icon, _vm.iconClass]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }